/**
 * Static record data for FB Doğuş
 * Contains checkpoints, stages and record times for the Hopa-İskenderun route
 */
const recordBoatData = {
  "name": "FB Doğuş",
  "race_info": {
    "title": "Hopa-İskenderun Rekor Yarışı",
    "total_distance_nm": 1400,
    "total_stages": 6
  },
  "checkpoints": [
    {
      "id": "START",
      "name": "START HATTI (Hopa Limanı)",
      "coordinates": {"lat": 41.42283, "lng": 41.42973},
      "type": "start"
    },
    {
      "id": "CP1",
      "name": "CHECK POINT-1 SİNOP", 
      "coordinates": {"lat": 42.11667, "lng": 34.94473},
      "type": "checkpoint"
    },
    {
      "id": "CP2", 
      "name": "CHECK POINT-2 BOĞAZLAR GİRİŞ",
      "coordinates": {"lat": 41.22897, "lng": 29.11507},
      "type": "checkpoint"
    },
    {
      "id": "CP3",
      "name": "CHECK POINT-3 ÇANAKKALE BOĞAZI ÇIKIŞI", 
      "coordinates": {"lat": 40.04150, "lng": 26.19118},
      "type": "checkpoint"
    },
    {
      "id": "CP4",
      "name": "CHECK POINT-4 KNİDOS GEÇİSİ",
      "coordinates": {"lat": 36.68742, "lng": 27.35670},
      "type": "checkpoint"
    },
    {
      "id": "CP5",
      "name": "CHECK POINT KIBRIS",
      "coordinates": {"lat": 35.72417, "lng": 34.60432},
      "type": "checkpoint"
    },
    {
      "id": "FINISH",
      "name": "FİNİSH HATTI (İskenderun)",
      "coordinates": {"lat": 36.12917, "lng": 36.17900},
      "type": "finish"
    }
  ],
  "stages": [
    {
      "stage": 1,
      "from": "START HATTI (Hopa Limanı)",
      "to": "CHECK POINT-1 SİNOP",
      "start_coords": {"lat": 41.42283, "lng": 41.42973},
      "end_coords": {"lat": 42.11667, "lng": 34.94473},
      "distance_nm": 295,
      "elapsed_time_hours": 61,
      "vmg": 4.84
    },
    {
      "stage": 2,
      "from": "CHECK POINT-1 SİNOP", 
      "to": "CHECK POINT-2 BOĞAZLAR GİRİŞ",
      "start_coords": {"lat": 42.11667, "lng": 34.94473},
      "end_coords": {"lat": 41.22897, "lng": 29.11507},
      "distance_nm": 265,
      "elapsed_time_hours": 54,
      "vmg": 4.91
    },
    {
      "stage": 3,
      "from": "CHECK POINT-2 BOĞAZLAR GİRİŞ",
      "to": "CHECK POINT-3 ÇANAKKALE BOĞAZI ÇIKIŞI",
      "start_coords": {"lat": 41.22897, "lng": 29.11507},
      "end_coords": {"lat": 40.04150, "lng": 26.19118},
      "distance_nm": 165,
      "elapsed_time_hours": 19,
      "vmg": 8.68
    },
    {
      "stage": 4,
      "from": "CHECK POINT-3 ÇANAKKALE BOĞAZI ÇIKIŞI",
      "to": "CHECK POINT-4 KNİDOS GEÇİSİ", 
      "start_coords": {"lat": 40.04150, "lng": 26.19118},
      "end_coords": {"lat": 36.68742, "lng": 27.35670},
      "distance_nm": 220,
      "elapsed_time_hours": 33,
      "vmg": 6.67
    },
    {
      "stage": 5,
      "from": "CHECK POINT-4 KNİDOS GEÇİSİ",
      "to": "CHECK POINT KIBRIS",
      "start_coords": {"lat": 36.68742, "lng": 27.35670}, 
      "end_coords": {"lat": 35.72417, "lng": 34.60432},
      "distance_nm": 360,
      "elapsed_time_hours": 53,
      "vmg": 6.79
    },
    {
      "stage": 6,
      "from": "CHECK POINT KIBRIS",
      "to": "FİNİSH HATTI (İskenderun)",
      "start_coords": {"lat": 35.72417, "lng": 34.60432},
      "end_coords": {"lat": 36.12917, "lng": 36.17900},
      "distance_nm": 95,
      "elapsed_time_hours": 22,
      "vmg": 4.32
    }
  ],
  // Calculate total metrics
  get totalDistanceNM() {
    return this.stages.reduce((total, stage) => total + stage.distance_nm, 0);
  },
  get totalElapsedTimeHours() {
    return this.stages.reduce((total, stage) => total + stage.elapsed_time_hours, 0);
  },
  get overallVMG() {
    return this.totalDistanceNM / this.totalElapsedTimeHours;
  }
};

export default recordBoatData;
